/**
 * Slack `mrkdwn` converter — a thin {@link FormatConverter} face over the
 * vendored CopilotKit translator. Interface-complete now; the Slack adapter
 * lands in a later rollout step.
 */
import { markdownToMrkdwn } from "../egress/vendor/markdown-to-mrkdwn.js";
import type { FormatConverter } from "./types.js";

/** {@link FormatConverter} for adapters whose `textFormat` is `"mrkdwn"` (Slack). */
export const mrkdwnFormatConverter: FormatConverter = { toPlatformText: markdownToMrkdwn };
